import { render } from "./FindInvitesPage.vue?vue&type=template&id=52d5ed54&ts=true"
import script from "./FindInvitesPage.vue?vue&type=script&lang=ts"
export * from "./FindInvitesPage.vue?vue&type=script&lang=ts"

import "./FindInvitesPage.vue?vue&type=style&index=0&id=52d5ed54&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__